import {
  media,
  layout,
  breakpoints,
  remCalc,
  pixelCalc,
  colors,
  campaignColors,
  brandColors,
  ratingStarColors,
} from './styles/variables';
import * as colorUtils from './src/color-utils';
import * as animationUtils from './src/animation-utils';
import * as animations from './src/animations';
import * as styledUtils from './src/styled-utils';
import browserSupports from './src/browser-support';
import defaultTheme from './styles/themes/default';
import darkTheme from './styles/themes/dark';
import StyledTheme from './styles/styled-theme';

const noop = () => {};

export {
  colors,
  campaignColors,
  brandColors,
  ratingStarColors,
  noop,
  media,
  layout,
  breakpoints,
  remCalc,
  pixelCalc,
  colorUtils,
  animationUtils,
  animations,
  styledUtils,
  browserSupports,
  defaultTheme,
  darkTheme,
  StyledTheme,
};
